import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Zigzag from "../components/common/Zigzag";
import { useNavigate } from "react-router-dom";
import { projects } from "../constants/projects";
import PageWrapper from "../components/common/RoutesWithAnimation";

function Projects() {
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <div className="w-100vw pt-5">
        <Container>
          <div
            className="position-relative mb-5 py-5 mt-5 mt-lg-0 text-center"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <h1 className="bolder fg-heading text-white mb-0">
              MY <span className="bolder primary-color">PROJECTS</span>
            </h1>
            <h1 className="bolder bg-title">PORTFOLIO</h1>
          </div>

          {projects.map((project, index) => (
            <Row className="project-div" key={index}>
              <Col
                md={{ order: index % 2, span: 6 }}
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <div
                  className={`h-100 w-100 d-flex align-items-center ${
                    index % 2 === 0
                      ? "justify-content-lg-start"
                      : "justify-content-lg-end"
                  } justify-content-center`}
                >
                  <div className="project-img-div">
                    <div className="project-img-before">
                      <img
                        className="project-img"
                        src={project.image}
                        alt={project.name}
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <Col
                md={{ order: index / 2, span: 6 }}
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                <div className="h-100 d-flex flex-column justify-content-center mt-3 mt-lg-0 px-3 px-md-0">
                  <h3 className="text-white bolder">{project.name}</h3>
                  <Zigzag />
                  <div className="text-white-50">{project.description}</div>
                  <div className="mt-4">
                    <button
                      onClick={() => navigate(`/project/${project.slug}`)}
                      type="submit"
                      className="button"
                    >
                      <span className="button-text">View Details</span>
                      <img
                        src="/assets/arrow.svg"
                        alt="send"
                        className="button-icon p-2"
                      />
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          ))}
        </Container>
      </div>
    </PageWrapper>
  );
}

export default Projects;
